import { render, staticRenderFns } from "./mycourse.vue?vue&type=template&id=956ac386&scoped=true&"
import script from "./mycourse.vue?vue&type=script&lang=js&"
export * from "./mycourse.vue?vue&type=script&lang=js&"
import style0 from "./mycourse.vue?vue&type=style&index=0&id=956ac386&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956ac386",
  null
  
)

export default component.exports